// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"y1-z","displaySixCardTiles":"z1-z"};